import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const Divider = styled.div`
    width: 1px;
    height: 8px;
    border-radius: 1px;
    background-color: ${({ theme }) => theme.Surface.border};
`;

export const Situation = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.Utility.critical};
`;
